import {
  GET_ORDERS,
  GET_ORDERS_FAIL,
  GET_ORDERS_SUCCESS,
  ADD_NEW_ORDER,
  ADD_ORDER_SUCCESS,
  ADD_ORDER_FAIL,
  UPDATE_ORDER,
  UPDATE_ORDER_SUCCESS,
  UPDATE_ORDER_FAIL,
  DELETE_ORDER,
  DELETE_ORDER_SUCCESS,
  DELETE_ORDER_FAIL,
  GET_ORDER_DETAIL,
  CONVERT_TO_ORDER_FAIL,
  CONVERT_TO_ORDER_SUCCESS,
  CONVERT_TO_ORDER,
} from "./actionTypes"

export const getOrders = props => ({
  type: GET_ORDERS,
  payload: props,

})

export const getOrdersSuccess = orders => ({
  type: GET_ORDERS_SUCCESS,
  payload: orders,
})

export const getOrdersFail = error => ({
  type: GET_ORDERS_FAIL,
  payload: error,
})

export const convertToOrder = orders => ({
  type: CONVERT_TO_ORDER,
  payload: orders,
})

export const convertToOrderSuccess = orders => ({
  type: CONVERT_TO_ORDER_SUCCESS,
  payload: orders,
})

export const convertToOrderFail = error => ({
  type: CONVERT_TO_ORDER_FAIL,
  payload: error,
})



export const addNewOrder = order => ({
  type: ADD_NEW_ORDER,
  payload: order,
})

export const addOrderSuccess = order => ({
  type: ADD_ORDER_SUCCESS,
  payload: order,
})

export const addOrderFail = error => ({
  type: ADD_ORDER_FAIL,
  payload: error,
})

export const updateOrder = order => ({
  type: UPDATE_ORDER,
  payload: order,
})

export const updateOrderSuccess = order => ({
  type: UPDATE_ORDER_SUCCESS,
  payload: order,
})

export const updateOrderFail = error => ({
  type: UPDATE_ORDER_FAIL,
  payload: error,
})

export const deleteOrder = order => ({
  type: DELETE_ORDER,
  payload: order,
})

export const deleteOrderSuccess = order => ({
  type: DELETE_ORDER_SUCCESS,
  payload: order,
})

export const deleteOrderFail = error => ({
  type: DELETE_ORDER_FAIL,
  payload: error,
})

export const getOrderDetails = order => ({
  type: GET_ORDER_DETAIL,
  payload: order,
})

export const getOrderDetailFail = error => ({
  type: GET_ORDER_DETAIL_FAIL,
  payload: error,
})


export const getOrderDetailSuccess = order => ({
  type: GET_ORDER_DETAIL_SUCCESS,
  payload: order,
})


